module.exports = __webpack_public_path__ + "img/iphone-mockup-1.da6960ad.png";